export enum SettingsEvents {
  SelectWorkspace = 'settings.SelectWorkspace',
  InviteToWorkspace = 'settings.InviteToWorkspace',
  SignOut = 'settings.SignOut'
}
